import React from 'react';
import { SupervisorLucroPage } from '../lucroFiscal/SupervisorLucroPage';

export function modulesHomeSupervisorLucroPresumidoPage() {
  return <SupervisorLucroPage regime="lucro_presumido" />;
}
